import CssBaseline from '@material-ui/core/CssBaseline';
import {
  jssPreset,
  StylesProvider,
  ThemeProvider,
} from '@material-ui/core/styles';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {BackButtonListener} from 'components/BackButton';
import {BottomSheetProvider} from 'components/BottomSheet';
import PreLoader from 'components/PreLoader';
import {googleAnalyticsTrackingCode, iranMode} from 'configs/app';
import theme from 'configs/theme';
import {StoreProvider, useStoreState} from 'easy-peasy';
import 'fontsource-roboto';
import {create} from 'jss';
import rtl from 'jss-rtl';
import ModalProvider from 'mui-modal-provider';
import {SnackbarProvider} from 'notistack';
import React, {Suspense, useEffect, useState} from 'react';
import ReactGA from 'react-ga4';
import {ReactQueryConfigProvider} from 'react-query';
import {Provider as ReduxProvider} from 'react-redux';
import {Redirect, Route, Router, Switch, useLocation} from 'react-router-dom';
import store from 'store';
import {BottomSheetConfigurator} from 'utils/bottom-sheet';
import JalaaliUtcUtils from 'utils/jalali-utc';
import 'utils/moment';
import {OutHookConfigurator} from 'utils/out-hook';
import routerHistory from 'utils/router-history';
import SnackbarUtil, {SnackbarUtilsConfigurator} from 'utils/snackbar';
import {init as initEventService} from 'services/Events';
import packageJson from '../package.json';
import {sleep} from './utils';
import NotFoundError from 'components/NotFoundPage';
import ServerDown from 'components/ServerDown';
// import Hotjar from '@hotjar/browser';
import SplashScreen from 'views/app/dashboard/SplashScreen';
import UserIncreaseModal from 'components/modals/userIncreaseModal';
import {useSelfInfo} from 'hooks/users';
import BestAdviserModal from 'components/modals/BestAdviserModal';
import api from 'services/Api';
import CanceledSessionModal from 'components/modals/canceledSession';
import {useHistory} from 'react-router-dom';
import {init as initMetrix} from '@metrixorg/websdk';
import {newEvent} from '@metrixorg/websdk';
import MaintenancePage from 'views/app/MaintenancePage';

const ViewApp = React.lazy(() => import('views/app'));
const ViewPublic = React.lazy(() => import('views/public'));
const ViewUser = React.lazy(() => import('views/user'));
const ViewError = React.lazy(() => import('views/error'));
const AddToHomeScreen = React.lazy(() => import('views/add-to-home-screen'));
const AutoLogin = React.lazy(() => import('views/auto-login'));
const PartnerLogin = React.lazy(() => import('views/partner-login'));

const PotlifeLogin = React.lazy(() => import('views/potlife-login'));

const AuthRoute = ({component: Component, loggedIn, ...rest}) => {
  const regex = RegExp(
    '/app/advisers/[0-f-]{36}/(booking|booking-homecare|booking-family-doctor)',
  );
  const exclude = regex.test(rest.location.pathname);

  return (
    <Route
      {...rest}
      render={(props) =>
        exclude || loggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/user/login',
              state: {from: props.location},
            }}
          />
        )
      }
    />
  );
};

// if (typeof InstallTrigger !== 'undefined') {
//   const originalError = console.error;
//   const originalWarn = console.warn;

//   console.error = function (...args) {
//     const msg = args.join(' ');
//     if (
//       msg.includes('NS_BINDING_ABORTED') ||
//       msg.includes('NS_BINDING') ||
//       msg.includes('NS_ERROR_ABORT')
//     ) {
//       return; // Completely ignore
//     }
//     originalError.apply(console, args);
//   };

//   console.warn = function (...args) {
//     const msg = args.join(' ');
//     if (
//       msg.includes('NS_BINDING_ABORTED') ||
//       msg.includes('NS_BINDING') ||
//       msg.includes('NS_ERROR_ABORT')
//     ) {
//       return;
//     }
//     originalWarn.apply(console, args);
//   };

//   console.log('🦊 Firefox console override activated');
// }

const APP_ID = 'kvgdivqbmmfstni';
const API_KEY = '11bc83ce-84fc-424d-810f-57c03622cc1f';

initMetrix(APP_ID, API_KEY, {
  sessionTracking: {
    enabled: true,
    packageName: 'com.pezeshket.web',
  },
});
newEvent('wzdvf', {
  time: new Date().toISOString(),
  page: window.location.pathname,
});

initEventService();
const jss = create({plugins: [...jssPreset().plugins, rtl()]});

function MaterialThemeProvider(props) {
  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <CssBaseline />
        {props.children}
      </StylesProvider>
    </ThemeProvider>
  );
}

const queryConfig = {
  queries: {
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: false,
  },
};

function Application() {
  const loggedIn = useStoreState((state) => state.auth.loggedIn);
  // const ignoreA2HS = useStoreState((state) => state.app.ignoreA2HS);

  return (
    <ReactQueryConfigProvider config={queryConfig}>
      <MaterialThemeProvider>
        <MuiPickersUtilsProvider utils={JalaaliUtcUtils} locale="fa">
          <Suspense fallback={<PreLoader />}>
            <Router history={routerHistory}>
              {/* {!loggedIn && !ignoreA2HS && !isIOS && <ForceAddToHomeScreen />} */}
              <ModalProvider>
                <BottomSheetProvider>
                  <SnackbarProvider
                    maxSnack={5}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    autoHideDuration={3 * 1000}>
                    <BottomSheetConfigurator />
                    <SnackbarUtilsConfigurator />
                    <OutHookConfigurator />
                    <BackButtonListener />
                    <Switch>
                      {/*<AuthRoute*/}
                      {/*  path="/app"*/}
                      {/*  loggedIn={loggedIn}*/}
                      {/*  component={ViewApp}*/}
                      {/*/>*/}
                      <Route
                        path="/app"
                        render={(props) => <ViewApp {...props} />}
                      />
                      <Route
                        path="/public"
                        render={(props) => <ViewPublic {...props} />}
                      />
                      <Route
                        path="/user"
                        render={(props) => <ViewUser {...props} />}
                      />
                      <Route
                        path="/error"
                        exact
                        render={(props) => <NotFoundError {...props} />}
                      />
                      <Route
                        path="/add-to-home-screen"
                        exact
                        render={(props) => <AddToHomeScreen {...props} />}
                      />

                      {/*<Route*/}
                      {/*  path="/auto-login/:refreshToken+"*/}
                      {/*  render={(props) => <AutoLogin {...props} />}*/}
                      {/*/>*/}

                      {/*<Route*/}
                      {/*  path="/partner-login"*/}
                      {/*  render={(props) => <PartnerLogin {...props} />}*/}
                      {/*/>*/}
                      <Route
                        path="/potlife-login/:data"
                        render={(props) => <PotlifeLogin {...props} />}
                      />

                      <Route
                        exact
                        path="/"
                        render={() =>
                          sessionStorage.getItem('packagePayment') ? (
                            <Redirect to="/app/package-pay-status" />
                          ) : (
                            <Redirect to="/app" />
                          )
                        }
                      />
                      <Route
                        path="/serverdown"
                        exact
                        render={(props) => <ServerDown {...props} />}
                      />
                    </Switch>
                  </SnackbarProvider>
                </BottomSheetProvider>
              </ModalProvider>
            </Router>
          </Suspense>
        </MuiPickersUtilsProvider>
      </MaterialThemeProvider>
    </ReactQueryConfigProvider>
  );
}

export default function App() {
  //hotjar
  const siteId = 5362543;
  const hotjarVersion = 6;
  const isAdviseSession = window.location.pathname.includes('advise-sessions');

  const [isIran, setIsInIran] = useState(true);
  const isIranExist = localStorage.getItem('isIran');

  useEffect(() => {
    setTimeout(() => {
      localStorage.setItem('isIran', isIran);
    }, 3000);
  }, []);

  // useEffect(() => {
  //   api
  //     .invoke('GET', 'core/v1/auth/region')
  //     .then((response) => {
  //       const {data} = response;
  //       setIsInIran(data?.isIran);
  //       // localStorage.setItem('isIran', data?.isIran);
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching region data:', error);
  //       localStorage.setItem('isIran', 'true');
  //     });
  // }, [isIranExist]);

  useEffect(() => {
    if (!isIran) {
      SnackbarUtil.warning(
        'با VPN تعرفه ها بین المللی اعمال میشود.لطفا فیلترشکن را خاموش کنید.',
      );
    }
  }, [isIran]);

  // useEffect(() => {
  //   if (isAdviseSession) {
  //     if (window.hj) {
  //       window.hj('optOut');
  //       window.hj('pauseRecording');
  //     }
  //   } else {
  //     if (!window.hj) {
  //       Hotjar.init(siteId, hotjarVersion);
  //     } else {
  //       window.hj('optIn');
  //       window.hj('resumeRecording');
  //     }
  //   }
  // }, [isAdviseSession]);

  useEffect(() => {
    ReactGA.initialize(googleAnalyticsTrackingCode);
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
    });
  }, []);
  //////////////////////
  const [canceledModal, setCanceledModal] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      const custom = e;

      if (custom.detail?.key === 'canceledModal') {
        console.log('canceledModal updated:', custom.detail.value);

        if (custom.detail.value === 'true') {
          setTimeout(() => {
            setCanceledModal(true);
          }, 8000);
        } else {
          setCanceledModal(false);
        }
      }
    };

    window.addEventListener('session-storage', handler);
    return () => window.removeEventListener('session-storage', handler);
  }, []);

  /////////splash screen//////////////////////////////
  const isIOS = /iphone|ipad|ipod/.test(
    window.navigator.userAgent.toLowerCase(),
  );
  const isInStandaloneMode = () =>
    window.matchMedia('(display-mode: standalone)').matches;
  const [loading, setLoading] = useState(() => {
    const splashShown = sessionStorage.getItem('splash-shown');
    return isInStandaloneMode() && isIOS && !splashShown;
  });

  const [openAccessModalInstant, setOpenAccessModalInstant] = useState(false);

  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleLocationChange);
    // Create a mutation observer to watch for URL changes
    const observer = new MutationObserver(() => {
      if (currentPath !== window.location.pathname) {
        setCurrentPath(window.location.pathname);
      }
    });

    // Observe changes to the URL
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      observer.disconnect();
    };
  }, [currentPath]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const hasShownModal = sessionStorage?.getItem(
        'hasShownUserIncreaseModal',
      );
      const isHomePage = window.location.pathname === '/app';

      if (!hasShownModal && isHomePage) {
        setOpenAccessModalInstant(true);
        sessionStorage.setItem('hasShownUserIncreaseModal', 'true');
      }
    }, 25000);

    return () => clearTimeout(timer);
  }, [currentPath]);

  useEffect(() => {
    if (loading && isInStandaloneMode()) {
      const timer = setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem('splash-shown', 'true');
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

  useEffect(() => {
    api
      .invoke('GET', 'core/v1/info/maintenance')
      .then(({data}) => setIsMaintenanceMode(!!data?.enabled))
      .catch(() => setIsMaintenanceMode(false));
  }, []);

  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  if (loading && isInStandaloneMode()) {
    return <SplashScreen />;
  }

  return (
    <ReduxProvider store={store}>
      <StoreProvider store={store}>
        <Application />
        {/* {openAccessModalInstant && (
          <BestAdviserModal
            openAccessModal={openAccessModalInstant}
            setOpenAccessModal={setOpenAccessModalInstant}
          />
        )} */}
        {canceledModal && (
          <CanceledSessionModal canceledModal={canceledModal} />
        )}
        {/* {openAccessModalInstant && (
          <UserIncreaseModal
            openAccessModal={openAccessModalInstant}
            setOpenAccessModal={setOpenAccessModalInstant}
          />
        )} */}
      </StoreProvider>
    </ReduxProvider>
  );
}

// export async function checkVersion() {
//   try {
//     const version = localStorage.getItem('version');

//     if (version !== packageJson.version) {
//       localStorage.setItem('version', packageJson.version);

//       // پاک کردن cache‌ها
//       if ('caches' in window) {
//         const keys = await caches.keys();
//         await Promise.all(keys.map((key) => caches.delete(key)));
//       }

//       // reload وقتی SW جدید فعال شد
//       if (navigator.serviceWorker?.controller) {
//         navigator.serviceWorker.addEventListener('controllerchange', () => {
//           setTimeout(() => {
//             window.location.reload();
//           }, 500); // تاخیر برای Safari
//         });
//       }

//       // کمی delay برای اطمینان
//       await new Promise((r) => setTimeout(r, 2000));
//     } else {
//       return packageJson.version;
//     }
//   } catch (e) {
//     console.error('checkVersion error:', e);
//   }
// }

export async function checkVersion() {
  try {
    let version = localStorage.getItem('version');
    if (version !== packageJson.version) {
      localStorage.setItem('version', packageJson.version);

      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });

        await sleep(3 * 1000);
        return <Redirect to="/" />;
      }
    } else {
      return packageJson.version;
    }
  } catch (e) {
    console.log(e);
  }
}

export function checkBooking(history) {
  const to = sessionStorage.getItem('booking');
  if (!!to) {
    history.push(to);
    sessionStorage.removeItem('booking');
  }
}

export function checkPackage(history) {
  const to = sessionStorage.getItem('package');
  if (!!to) {
    history.push({
      pathname: to,
      state: {
        showModal: true,
      },
    });
    sessionStorage.removeItem('package');
  }
}

export function checkPsychologyInstanceCall(history) {
  const to = sessionStorage.getItem('psychologyInstanceCall');
  if (!!to) {
    history.push(to);
    sessionStorage.removeItem('psychologyInstanceCall');
  }
}

export function checkAdviseSessionChat(history) {
  const to = sessionStorage.getItem('adviseSessionChat');
  if (!!to) {
    history.push(to);
    sessionStorage.removeItem('adviseSessionChat');
  }
}

export function checkMedicineInstanceCall(history) {
  const to = sessionStorage.getItem('medicineInstanceCall');
  if (!!to) {
    history.push(to);
    sessionStorage.removeItem('medicineInstanceCall');
  }
}

export function checkBecomeAdviser(history) {
  const to = sessionStorage.getItem('becomeAdviser');
  if (!!to) {
    history.push(to);
    sessionStorage.removeItem('becomeAdviser');
  }
}
